import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../constants/endpoints'

interface TimeResponse {
  currentDateTime: string
}
class TimeService {
  getCurrentDateTime(abortController?: AbortController): Promise<string> {
    return HttpService.get<TimeResponse>(Endpoint.GET_CURRENT_DATE_TIME, undefined, {abortController})
      .then(response => {
        if (!response.body?.currentDateTime)  {
          return Promise.reject();
        }
        return response.body.currentDateTime;
      });
  }
}

const timeService = new TimeService();

Object.freeze(timeService);

export default timeService;
